import { render, staticRenderFns } from "./SubOrderListCard.vue?vue&type=template&id=ffed1930&scoped=true&"
import script from "./SubOrderListCard.vue?vue&type=script&lang=js&"
export * from "./SubOrderListCard.vue?vue&type=script&lang=js&"
import style0 from "./SubOrderListCard.vue?vue&type=style&index=0&id=ffed1930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffed1930",
  null
  
)

/* custom blocks */
import block0 from "./SubOrderListCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports